var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-info',{staticClass:"card-info",scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_vm._t("buttons")]},proxy:true}],null,true)},[_c('div',{staticClass:"card-info__line-items"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }